<template>
  <v-navigation-drawer :mini-variant.sync="mini" mini-variant-width="72" permanent fixed v-model="drawer" width="256"
    app style="z-index: 99999">
    <div v-if="mini" class="nav-title">
      <v-btn @click="mini = !mini" color="accent lighten-1" min-width="0" max-width="24" max-height="24"
        class="pa-0 ma-0 btn-nav-title-close">
        <v-icon color="primary">icon-alertadis-angle-right-b</v-icon>
      </v-btn>
      <v-img class="ml-3" max-height="32" max-width="30" src="@/assets/logo-alerta.png"></v-img>
    </div>
    <div v-else class="nav-title">
      <v-img class="ml-4" max-height="40" max-width="38" src="@/assets/logo-alerta.png"></v-img>
      <v-spacer></v-spacer>
      <v-btn @click="mini = !mini" color="accent lighten-1" min-width="0" width="32" tile class="btn-nav-title-open">
        <v-icon class="mr-2" color="primary">icon-alertadis-angle-left-b</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <section style="height: 84vh" class="d-flex">
      <div style="width: 72px" class="pt-2">
        <div id="my-btn-group">
          <div class="div-btn active">
            <v-tooltip right content-class="arrow tooltip-right" color="secondary lighten-3">
              <template v-slot:activator="{ on, attrs }">
                <button class="btn" v-bind="attrs" v-on="on" @click="navigateDrawer(1)">
                  <v-icon>icon-alertadis-apps</v-icon>
                </button>
              </template>
              <span>Menu</span>
            </v-tooltip>
          </div>
          <div class="div-btn">
            <v-tooltip right content-class="arrow tooltip-right" color="secondary lighten-3">
              <template v-slot:activator="{ on, attrs }">
                <v-badge overlap color="red" :content="weatherAlertsCount" :value="weatherAlertsCount > 0">
                  <button class="btn" v-bind="attrs" v-on="on" @click="navigateDrawer(2)">
                    <v-icon>icon-alertadis-thunderstorm-sun</v-icon>
                  </button>
                </v-badge>
              </template>
              <span>Alertas meteorológicos</span>
            </v-tooltip>
          </div>
          <div class="div-btn">
            <v-tooltip right content-class="arrow tooltip-right" color="secondary lighten-3">
              <template v-slot:activator="{ on, attrs }">
                <v-badge overlap color="red" :content="interruptionNotificationCount"
                  :value="interruptionNotificationCount > 0">
                  <button class="btn" v-bind="attrs" v-on="on" @click="navigateDrawer(3)">
                    <v-icon>icon-alertadis-lightbulb-off-outline</v-icon>
                  </button>
                </v-badge>
              </template>
              <span>Alertas de interrupções</span>
            </v-tooltip>
          </div>
        </div>
      </div>
      <v-divider v-if="!mini" vertical></v-divider>
      <div v-if="!mini" style="width: 184px" class="overflow-auto component-area">
        <component :is="selectedDrawerScreen"></component>
      </div>
    </section>

    <div class="bottom">
      <v-divider></v-divider>
      <v-row no-gutters>
        <v-col :cols="mini ? '12' : '2'" :class="mini ? 'pl-3' : 'pl-0'">
          <v-tooltip right content-class="arrow tooltip-right" color="secondary lighten-3">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn depressed v-bind="attrs" v-on="on" href="/files/AlertaDIS - Manual do Usuário - Web.pdf" download
                  min-width="0" max-width="28" max-height="28" @click.stop
                  :color="hover ? 'secondary lighten-3' : 'secondary lighten-1'" class="ma-1"><v-icon size="18"
                    color="primary">mdi-help-circle-outline</v-icon></v-btn>
              </v-hover>
            </template>
            <span class="tooltip-text">Manual do usuário</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="!mini" cols="10">
          <div class="d-flex align-center pt-0">
            <v-btn class="pl-2 user-name" text href="/files/AlertaDIS - Manual do Usuário - Web.pdf" @click.stop
              style="text-transform:none;">Manual do usuário</v-btn>
          </div>
        </v-col>
        <v-col :cols="mini ? '12' : '2'" :class="mini ? 'pl-3' : 'pl-0'">
          <v-tooltip right content-class="arrow tooltip-right" color="secondary lighten-3">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn depressed v-bind="attrs" v-on="on" min-width="0" max-width="28" max-height="28"
                  :color="hover ? 'secondary lighten-3' : 'secondary lighten-1'" class="ma-1"
                  @click.stop="goToConfig"><v-icon size="18" color="primary">icon-alertadis-setting</v-icon></v-btn>
              </v-hover>
            </template>
            <span class="tooltip-text">Configurações</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="!mini" cols="10">
          <div class="d-flex align-center pt-2">
            <a class="pl-2 user-name" @click.stop="goToConfig">Configurações</a>
          </div>
        </v-col>
      </v-row>

      <!--    <v-divider></v-divider>
      <div
        :class="
          mini
            ? 'py-2 d-flex flex-column align-center justify-space-around'
            : 'py-2 d-flex flex-column  justify-space-around'
        "
        :style="mini ? 'min-height: 40px' : 'height: 40px'"
      >
        <div>
          <v-tooltip
            right
            content-class="arrow tooltip-right"
            color="secondary lighten-3"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  href="/files/AlertaDIS - Manual do Usuário - Web.pdf"
                  download
                  min-width="0"
                  max-width="28"
                  max-height="28"
                  @click.stop
                  :color="hover ? 'secondary lighten-3' : 'secondary lighten-1'"
                  class="ma-1"
                  ><v-icon size="18" color="primary"
                    >mdi-help-circle-outline</v-icon
                  ></v-btn
                >
              </v-hover>
            </template>
            <span class="tooltip-text">Manual do usuário</span>
          </v-tooltip>
          <div v-if="!mini" class="pa-1 d-flex">
          <div class="d-flex align-center">
            <span class="pl-2 user-name">Manual do usuário</span>
          </div>
        </div>
        </div>

        <div>
          <v-tooltip
            right
            content-class="arrow tooltip-right"
            color="secondary lighten-3"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  min-width="0"
                  max-width="28"
                  max-height="28"
                  :color="hover ? 'secondary lighten-3' : 'secondary lighten-1'"
                  class="ma-1"
                  @click.stop="goToConfig"
                  ><v-icon size="18" color="primary"
                    >icon-alertadis-setting</v-icon
                  ></v-btn
                >
              </v-hover>
            </template>
            <span class="tooltip-text">Configurações</span>
          </v-tooltip>

        </div>

      </div> -->
      <v-divider></v-divider>
      <div :class="mini
        ? 'py-2 d-flex flex-column align-center justify-space-around'
        : 'py-2 d-flex justify-space-around align-center'
        " :style="mini ? 'min-height: 132px' : 'height: 68px'">
        <div>
          <v-avatar class="ma-1 avatar" size="36"> {{ avatar }} </v-avatar>
        </div>
        <div v-if="!mini" class="pa-1 d-flex flex-column">
          <div class="d-flex align-center">
            <v-tooltip content-class="arrow tooltip-top redefine-btn-tooltip" top max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="14" v-if="isAdmin(currentUser.attributes.roles)">
                  icon-alertadis-shield-account
                </v-icon>
              </template>
              <span>Usuário Administrador</span>
            </v-tooltip>

            <span class="pl-2 user-name">{{ userDetails.name }}</span>
          </div>
          <span class="user-role">{{ userDetails ? userDetails.departmentName : "" }}
          </span>
        </div>
        <div>
          <v-tooltip right content-class="arrow tooltip-right" color="secondary lighten-3">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn depressed v-bind="attrs" v-on="on" min-width="0" width="28" min-height="0" height="28"
                  :color="hover ? 'secondary lighten-3' : 'secondary lighten-1'" class="ma-1"
                  @click.stop="logOut"><v-icon size="18" color="primary">icon-alertadis-signout</v-icon></v-btn>
              </v-hover>
            </template>
            <span class="tooltip-text">Sair</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import routes from "@/router/routes";
import Menu from "./navigation/Menu.vue";
import WeatherAlert from "./navigation/WeatherAlert.vue";
import ShutdownAlert from "./navigation/ShutdownAlert.vue";
import { mapGetters } from "vuex";

export default {
  name: "DrawerNavigation",
  props: ["menu", "permanent", "clipped", "user"],
  data: () => ({
    isProduction: process.env.NODE_ENV === "production",
    drawer: true,
    mini: true,
    selectedDrawerScreen: null,
    currentUser: null,
    interruptionNotificationRegionalCount: 0,
    interruptionNotificationAgencyCount: 0,
    interruptionNotificationCountieCount: 0,
    refreshInterruptionNotificationsProp: null,
    weatherAlertsCount: 0,
  }),
  async mounted() {
    this.navigateDrawer(1);
    this.currentUser = this.$store.getters.currentUser;
    this.menuButtons();
    await this.fetchUsernotifications();
    this.refreshInterruptionNotifications();

    await this.$store.dispatch("fetchAlertsActive", {
      name: this.$locationFilter.location.name,
      locations: this.$locationFilter.location.locations,
      typeAlert: "menu",
    });
    this.weatherAlertsNotificationCount();
  },
  watch: {
    dailyInterruptionsNotificationsRegionalData: {
      deep: true,
      handler(value) {
        if (value) {
          this.verifyIterruptionNotificationRegionalCount();
        }
      },
    },
    dailyInterruptionsNotificationsAgencyData: {
      deep: true,
      handler(value) {
        if (value) {
          this.verifyIterruptionNotificationAgencyCount();
        }
      },
    },
    dailyInterruptionsNotificationsCoutiesData: {
      deep: true,
      handler(value) {
        if (value) {
          this.verifyIterruptionNotificationCountiesCount();
        }
      },
    },

    alertsActiveMenu: {
      deep: true,
      handler(value) {
        if (value) {
          this.weatherAlertsNotificationCount();
        }
      },
    },
  },
  methods: {
    navigateDrawer(id) {
      const alertIds = [];
      switch (id) {
        case 1:
          this.selectedDrawerScreen = Menu;
          break;
        case 2:
          this.alertsActiveMenu.forEach((e) => {
            if (e.data && e.data.length > 0) {
              e.data.forEach((item) => {
                const id = `${item.date}-${item.alertArea}-${item.type}`;
                alertIds.push(id);
              });
            }
          });
          sessionStorage.setItem(
            "alertsSeen",
            JSON.stringify(alertIds)
          );
          this.weatherAlertsCount = 0;
          this.selectedDrawerScreen = WeatherAlert;
          break;
        case 3:
          this.interruptionNotificationRegionalCount = 0;
          this.interruptionNotificationAgencyCount = 0;
          this.interruptionNotificationCountieCount = 0;
          this.selectedDrawerScreen = ShutdownAlert;
          break;
        default:
          break;
      }
    },
    goToConfig() {
      this.$router.push(routes.userConfig.path).catch((err) => err);
    },
    logOut() {
      this.$store.dispatch("logOut");
      this.$router.push(routes.login.path);
    },
    menuButtons() {
      let header = document.getElementById("my-btn-group");
      let btns = header.getElementsByClassName("div-btn");
      for (let i = 0; i < btns.length; i++) {
        const btn = btns[i];
        btn.addEventListener("click", function () {
          const current = document.getElementsByClassName("active");
          current[0].className = current[0].className.replace(" active", "");
          this.className += " active";
          //declarar 'e' como parametro da funcao
          //e.stopPropagation()
        });
      }
    },
    isAdmin(roles) {
      const substring1 = "AlertaDIS_SUPER_USER";
      const substring2 = "AlertaDIS_ADMIN";

      if (!Array.isArray(roles)) {
        roles = [roles];
      }

      const match = roles.find((element) => {
        if (element.includes(substring1) || element.includes(substring2)) {
          return true;
        }
      });

      if (match !== undefined) return true;

      return false;
    },
    async fetchUsernotifications() {
      await this.$store.dispatch("fetchDailyInterruptionRegionalNotifications");
      await this.$store.dispatch("fetchDailyInterruptionAgencyNotifications");
      await this.$store.dispatch("fetchDailyInterruptionCountieNotifications");

      await this.$store.dispatch("fetchAlertsActive", {
        name: this.$locationFilter.location.name,
        locations: this.$locationFilter.location.locations,
        typeAlert: "allAlerts",
      });
    },
    async refreshInterruptionNotifications() {
      this.refreshInterruptionNotificationsProp = setInterval(() => {
        this.fetchUser, this.fetchUsernotifications();
      }, 300000);
      //300000 == 5 minutos
    },
    verifyIterruptionNotificationRegionalCount() {
      const data = sessionStorage.getItem("interruptionNotificationsRegional");
      let count = 0;
      if (data) {
        let regionalArr = JSON.parse(data);
        if (
          this.dailyInterruptionsNotificationsRegionalData.length >
          regionalArr.length
        ) {
          count =
            this.dailyInterruptionsNotificationsRegionalData.length -
            regionalArr.length;
        } else if (
          this.dailyInterruptionsNotificationsRegionalData.length ==
          regionalArr.length
        ) {
          this.dailyInterruptionsNotificationsRegionalData.forEach((org) => {
            regionalArr.forEach((temp) => {
              if (org.data.lenght != temp.data.lenght) {
                count = 1;
              }
            });
          });
        } else {
          count = 0;
        }
        this.interruptionNotificationRegionalCount = count;
      }
      sessionStorage.setItem(
        "interruptionNotificationsRegional",
        JSON.stringify(this.dailyInterruptionsNotificationsRegionalData)
      );
    },
    verifyIterruptionNotificationAgencyCount() {
      const data = sessionStorage.getItem("interruptionNotificationsAgency");
      let count = 0;
      if (data) {
        let agencyArr = JSON.parse(data);
        if (
          this.dailyInterruptionsNotificationsAgencyData.length >
          agencyArr.length
        ) {
          count =
            this.dailyInterruptionsNotificationsAgencyData.length -
            agencyArr.length;
        } else if (
          this.dailyInterruptionsNotificationsAgencyData.length ==
          agencyArr.length
        ) {
          this.dailyInterruptionsNotificationsAgencyData.forEach((org) => {
            agencyArr.forEach((temp) => {
              if (org.data.lenght != temp.data.lenght) {
                count = 1;
              }
            });
          });
        } else {
          count = 0;
        }
        this.interruptionNotificationAgencyCount = count;
      }
      sessionStorage.setItem(
        "interruptionNotificationsAgency",
        JSON.stringify(this.dailyInterruptionsNotificationsAgencyData)
      );
    },
    verifyIterruptionNotificationCountiesCount() {
      const data = sessionStorage.getItem("interruptionNotificationsCounties");
      let count = 0;
      if (data) {
        let countiesArr = JSON.parse(data);
        if (
          this.dailyInterruptionsNotificationsCoutiesData.length >
          countiesArr.length
        ) {
          count =
            this.dailyInterruptionsNotificationsCoutiesData.length -
            countiesArr.length;
        } else if (
          this.dailyInterruptionsNotificationsCoutiesData.length ==
          countiesArr.length
        ) {
          for (let i in this.dailyInterruptionsNotificationsCoutiesData) {
            if (
              this.dailyInterruptionsNotificationsCoutiesData[i].locationId !=
              countiesArr[i].locationId
            ) {
              count = 1;
            }
          }
        }
        this.interruptionNotificationCountieCount = count;
      }
      sessionStorage.setItem(
        "interruptionNotificationsCounties",
        JSON.stringify(this.dailyInterruptionsNotificationsCoutiesData)
      );
    },

    weatherAlertsNotificationCount() {
      const alertsSeen = JSON.parse(sessionStorage.getItem("alertsSeen"));
      const alertIds = [];
      let alertsCount = 0;
      this.weatherAlertsCount = 0;
      this.alertsActiveMenu.forEach((e) => {
        alertsCount += e.data.length;
        if (e.data && e.data.length > 0) {
          e.data.forEach((item) => {
            const id = `${item.date}-${item.alertArea}-${item.type}`;
            alertIds.push(id);
          })
        }
      });

      if (alertsSeen) {
        alertsCount = 0;
        alertIds.forEach((alert) => {
          if (!alertsSeen.includes(alert)) alertsCount++
        });
      }
      this.weatherAlertsCount = alertsCount;
    },
  },
  computed: {
    ...mapGetters([
      "userDetails",
      "dailyInterruptionsNotificationsRegionalData",
      "dailyInterruptionsNotificationsAgencyData",
      "dailyInterruptionsNotificationsCoutiesData",
      "alertsActiveMenu",
    ]),
    avatar() {
      const avatar = this.$store.getters.currentUser.attributes.name.split(" ");
      return avatar.length > 1
        ? avatar[0].substr(0, 1) + avatar[1].substr(0, 1)
        : "AD";
    },
    interruptionNotificationCount() {
      return (
        this.interruptionNotificationRegionalCount +
        this.interruptionNotificationAgencyCount +
        this.interruptionNotificationCountieCount
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
}

.btn-nav-title-open {
  border-radius: 10px 0px 0px 10px;
}

.btn-nav-title-close {
  border-radius: 0px 8px 8px 0px;
}

.component-area {
  -ms-overflow-style: none;
  /* for Internet Explorer, Edge */
  scrollbar-width: none;
  /* for Firefox */
  overflow-y: scroll;
  padding: 1px;
}

.component-area::-webkit-scrollbar {
  display: none;
  /* for Chrome, Safari, and Opera */
}

.bottom {
  position: absolute;
  background-color: var(--v-secondary-base);
  bottom: 0px;
  width: 100%;
}

.user-name {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.user-role {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
}

.avatar {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
  background-color: var(--v-secondary-lighten1);
}

.tooltip-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
}

.tooltip-right::before {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%;
  /* To the left of the tooltip */
  margin-top: -6px;
  border-width: 6px;
  border-style: solid;
  border-top: solid 6px transparent;
  border-bottom: solid 6px transparent;
  border-left: solid 6px transparent;
}

.tooltip-right.arrow::before {
  border-right: solid 6px var(--v-secondary-lighten3) !important;
}

#my-btn-group {
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 16px;

    .btn {
      border-radius: 8px;
      height: 40px;
      width: 40px;
      background-color: var(--v-secondary-lighten1);
    }

    .btn:hover {
      background-color: var(--v-secondary-lighten3);
    }
  }
}

.active {
  border-left: 3px solid var(--v-primary-base);
  padding-right: 3px;
}

.redefine-btn-tooltip {
  opacity: 0.9;
  background: var(--v-secondary-lighten3);
}

.tooltip-top::before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: "";
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-top.arrow::before {
  opacity: 0.9;
  border-top: solid 6px var(--v-secondary-lighten3) !important;
}
</style>
